import O1HD from "../../../../engines/gameEngine";
import OreConfig, {OreEntity, OreSelectEntity} from "./config/OreConfig";
import DigSuccessNode from "./DigSuccessNode";
import OreItemNode from "./OreItemNode";
import PackageEnlargeCapacity from "./PackageEnlargeCapacity";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;
/**
 * 矿地
 */
@ccclass
export default class MineLandNode extends cc.Component {

    @property({type:cc.Node,displayName:"背景节点"})
    bgNode : cc.Node = null;
    @property({type:cc.Node,displayName:"添加背景节点"})
    oreBgNode : cc.Node = null;
    @property({type:cc.Node,displayName:"金属探测仪节点"})
    spSounderNode : cc.Node = null;
    @property({type:sp.Skeleton,displayName:"铁镐"})
    spTieGao : sp.Skeleton = null;
    @property({type:cc.Node,displayName:"ui 节点"})
    uiNode : cc.Node = null;
    @property({type:cc.Node,displayName:"矿石添加节点"})
    oreAddNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"矿石itemNode 预制体"})
    oreItemPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"相机Node"})
    cameraNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"挖矿成功预制体"})
    digSuccessPrefab : cc.Prefab = null;

    @property({type:cc.Node,displayName:"探测仪按钮"})
    btnSounderNode : cc.Node = null;
    @property({type:cc.Node,displayName:"挖按钮"})
    btnDigNode : cc.Node = null;
    @property({type:cc.Node,displayName:"背包节点按钮"})
    btnPackageNode : cc.Node = null;
    @property(cc.Label)
    lbNotice : cc.Label = null;
    @property({type:cc.Prefab,displayName:"背包扩容"})
    packageEnlargeCapacityPrefab : cc.Prefab = null;

    //当前选择扫描仪 的开关
    mCurrChooseSounderFlag : boolean = false;
    //临时 探测仪 node
    private tempSounderNode : cc.Node;
    //矿石 数组
    private mOreArray : OreEntity[] = [];
    //矿石下标 数组
    private mOreIndexArray : number[] = [];
    //镜头拉近开关
    cameraFlag : boolean = false;
    //当前挖掘次数
    mCurrDigCount : number = 0;
    //可用挖掘次数
    mCanUseDigCount : number = 16;
    //当前背包已用容量
    mCurrPackageCount : number = 0;
    //可用背包容量
    mCanUsePackageCount : number = 6;
    //距离
    distanceOre : number = null;

    private getOreArray : number[] = [];

    itemConfig:OreSelectEntity = null;

    bindData( config:OreSelectEntity ){
        this.itemConfig = config;
    }

    setDistance( tempDistance : number ){
        if ( this.distanceOre ) {
            if ( this.distanceOre > tempDistance ) {
                this.distanceOre = tempDistance;
            }
        }else{
            this.distanceOre = tempDistance;
        }
    }

    //刷新距离
    refreshDistanceNotice(){
        this.lbNotice.string = `附近没有哦`;
        if ( !this.distanceOre ){
            this.lbNotice.node.parent.active = false;
            this.lbNotice.string = `附近没有哦`;
        }else if ( this.distanceOre <= 200 ) {
            this.lbNotice.node.parent.active = true;
            this.lbNotice.string = `近在咫尺了`;
        }else if ( this.distanceOre <= 400 ) {
            this.lbNotice.node.parent.active = true;
            this.lbNotice.string = `距离临近了`;
        }else if ( this.distanceOre <= 600 ){
            this.lbNotice.node.parent.active = true;
            this.lbNotice.string = `距离比较远`;
        }else {
            this.lbNotice.node.parent.active = true;
            this.lbNotice.string = `附近没有哦`;
        }
    }


    onLoad () {
        this.bgNode.on("touchstart", this.touchStart , this );
        this.bgNode.on("touchmove", this.touchMove , this );
        this.bgNode.on("touchend", this.touchEnd , this );
        this.bgNode.on("touchcancel", this.touchCancel , this );
    }

    start () {
        this.onRefreshGameData();
        cc.macro.ENABLE_MULTI_TOUCH = false;
    }

    private mCurrFingerPos : cc.Vec2 = null;

    touchStart( e : cc.Event.EventTouch ){
        if ( !this.cameraFlag && this.mCurrChooseSounderFlag ) {
            this.mCurrFingerPos = e.getLocation();
            this.tempSounderNode = cc.instantiate( this.spSounderNode );
            this.tempSounderNode.active = true;
            let relPos = this.uiNode.convertToNodeSpaceAR( e.getLocation() );
            this.tempSounderNode.setPosition( cc.v2( relPos.x , relPos.y + 40 ) );
            this.uiNode.addChild( this.tempSounderNode );
            //放下触发
            this.mCurrFingerPos = e.getLocation();
            O1HD.emit("OreItemNode.checkJudgeNode" , cc.v2( e.getLocation().x , e.getLocation().y + 100 ) );
            //刷新提示
            this.refreshDistanceNotice();
            this.schedule( this.refreshDistanceNotice , 1 );
        }
    }

    touchMove( e : cc.Event.EventTouch ){
        let delta =  e.getDelta();
        if( !this.mCurrChooseSounderFlag ){
            this.bgNode.x += delta.x;
            this.bgNode.y += delta.y;
            if ( this.bgNode.y > -875 ) {
                this.bgNode.y = -875;
            }
            if ( this.bgNode.y < -2209 ) {
                this.bgNode.y = -2209
            }
            if ( this.bgNode.x < -750 ) {
                this.bgNode.x = -750
            }
            if ( this.bgNode.x > 750 ) {
                this.bgNode.x = 750
            }
        }else{
            this.distanceOre = null;
            //金属探测仪
            if ( !this.cameraFlag && this.tempSounderNode ) {
                this.tempSounderNode.x += delta.x;
                this.tempSounderNode.y += delta.y;
                this.mCurrFingerPos = e.getLocation();
                O1HD.emit("OreItemNode.checkJudgeNode" , cc.v2( e.getLocation().x , e.getLocation().y + 100 ) );
            }
        }
    }

    touchEnd(){
        this._closeTempNode();
    }

    touchCancel(){
        this._closeTempNode();
    }


    private _closeTempNode(){
        if ( this.tempSounderNode ) {
            this.mCurrFingerPos = null;
            this.tempSounderNode.removeFromParent();
            this.tempSounderNode.destroy();
            this.tempSounderNode = null;
            this.hasDetectionFlag = false;
            this.unschedule( this.refreshDistanceNotice );
            this.distanceOre = null;
            this.refreshDistanceNotice();
        }
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }
    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 选择金属探测仪
     */
    onBtnSounder( e , define ){
        this.mCurrChooseSounderFlag = !this.mCurrChooseSounderFlag;
        this.btnSounderNode.getChildByName("closeBtn").active = this.mCurrChooseSounderFlag;
    }


    /**
     * 刷新游戏数据
     */
    onRefreshGameData(){
        //获取所有的矿石数组
        this.mOreArray = JSON.parse( JSON.stringify(  this.itemConfig?.configs || OreConfig() ));
        this.mOreIndexArray = [];
        for ( let i = 1 ;i <= 45 ; i ++ ) {
            this.mOreIndexArray.push( i );
        }

        let needJumpIndex : number[] = [10,17,45];
        let currIndex : number = 0;
        //初始化48个矿石坑
        for ( let i = 0 ; i < 48 ; i ++ ) {
            let oreItemNode = cc.instantiate( this.oreItemPrefab );
            this.oreAddNode.addChild( oreItemNode );
            if ( needJumpIndex.includes( i ) == false ) {
                oreItemNode.getComponent( OreItemNode ).setIndex( currIndex ++ );
            }
            // let oreData = this.getRandomOreData();
            // let oreIndex = this.getRandomOreIndex();
            // O1HD.emit("OreItemNode.activeData" , oreIndex , this , oreData );
        }

        //场景加载10个矿石
        this.scheduleOnce(()=>{
            for ( let i = 0 ; i < 10 ; i ++ ) {
                let oreData = this.getRandomOreData();
                let oreIndex = this.getRandomOreIndex();
                O1HD.emit("OreItemNode.activeData" , oreIndex , this , oreData );
            }
        },0.3 );
    }

    /**
     * 获取随机的 不重复矿石资源
     */
    getRandomOreData() : OreEntity{
        let randomIndex = Math.floor( Math.random() * 100 )  ;
        // console.log("randomIndex",randomIndex);
        for ( let i = 0 ; i < this.mOreArray.length ; i ++ ) {
            let oreItem = this.mOreArray[i];
            if ( randomIndex <= oreItem.weight ) {
                return oreItem;
            }
            randomIndex -= oreItem.weight;
        }
    }

    /**
     * 获取随机的 矿石下标
     */
    getRandomOreIndex() : number{
        let randomIndex = Math.floor( Math.random() * this.mOreIndexArray.length );
        let randomNumArray = this.mOreIndexArray.splice( randomIndex , 1 );
        return randomNumArray[0];
    }

    //当前下标
    private mCurrIndex : number = 0;
    /**
     * 拉近 镜头
     */
    closeCamera( pos : cc.Vec2 , oreData : OreEntity , itemIndex : number){
        if ( this.cameraFlag ){
            return;
        }
        this.unschedule( this.refreshDistanceNotice );
        this.distanceOre = null;
        this.refreshDistanceNotice();
        this.mCurrIndex = itemIndex;
        this.btnSounderNode.active = false;
        this.btnDigNode.active = true;

        if ( this.tempSounderNode ) {
            this.tempSounderNode.removeFromParent();
            this.tempSounderNode.destroy();
            this.tempSounderNode = null;
        }
        let relPos = this.cameraNode.convertToNodeSpaceAR( pos );
        this.cameraFlag = true;
        cc.tween( this.cameraNode )
            .to( 0.5 , { x : relPos.x , y : relPos.y } )
            .call(()=>{

            })
            .start();
        cc.tween( this.cameraNode.getComponent( cc.Camera ))
            .to( 0.5 , { zoomRatio : 1.4 })
            .start();
    }

    private digFlag : boolean = true;
    /**
     * 铁镐 挖掘
     */
    onBtnDig(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( this.digFlag == false ) {
            return ;
        }
        this.digFlag = false;
        this.dig( );
        // this.btnDigNode.getChildByName("lb").getComponent(cc.Label).string = `${this.mCurrDigCount}/${this.mCanUseDigCount}`;
        O1HD.emit("OreItemNode.onDig" , this.mCurrIndex );
    }

    /**
     * 铁镐动作
     */
    dig(  ){
        this.spTieGao.node.active = true;
        this.spTieGao.setCompleteListener(()=>{
            this.spTieGao.node.active = false;
            this.digFlag = true;
        });
        O1HD.getManagers().soundMgr.playSound("dig").then();
        this.spTieGao.setAnimation( 0 , "animation" , false );
    }

    /**
     * 打开成功 挖掘 预制体
     */
    openSuccessDigNode( oreEntity : OreEntity ){
        this.scheduleOnce(()=>{
            let digSuccessPrefabNode = cc.instantiate( this.digSuccessPrefab );
            digSuccessPrefabNode.getComponent( DigSuccessNode ).bindData( oreEntity , this ).then( );
            this.uiNode.addChild( digSuccessPrefabNode );
        });
    }

    /**
     * 检测手指Pos
     */
    getFingerPos (  ) : cc.Vec2{
        if ( !this.mCurrFingerPos ){
            return null;
        }
        return  cc.v2(this.mCurrFingerPos.x , this.mCurrFingerPos.y + 100 );
    }

    hasDetectionFlag : boolean = false;
    /**
     * 探测仪 效果
     */
    soundEffect( level : number ){
        if ( this.tempSounderNode && this.hasDetectionFlag == false ) {
            // this.tempSounderNode.getComponent(sp.Skeleton).setCompleteListener(()=>{
            //     this.hasDetectionFlag = false;
            //     if ( this.mCurrFingerPos ){
            //         O1HD.emit("OreItemNode.checkEffect" , cc.v2( this.mCurrFingerPos.x , this.mCurrFingerPos.y + 100 ) );
            //     }
            // });
            this.scheduleOnce(()=>{
                this.hasDetectionFlag = false;
                if ( this.mCurrFingerPos ){
                    O1HD.emit("OreItemNode.checkEffect" , cc.v2( this.mCurrFingerPos.x , this.mCurrFingerPos.y + 100 ) );
                }
            },0.3 );
            this.hasDetectionFlag = true;
            switch ( level ) {
                case 0:
                    this.tempSounderNode.getComponent(sp.Skeleton).setAnimation( 0 , null , false );
                    break;
                case 1:
                    // console.log("触发1")
                    O1HD.getManagers().soundMgr.playSound("detection_mid").then();
                    this.tempSounderNode.getComponent(sp.Skeleton).setAnimation( 0 , "01" , false );
                    break;
                case 2:
                    // console.log("触发2")
                    O1HD.getManagers().soundMgr.playSound("detection_has").then();
                    this.tempSounderNode.getComponent(sp.Skeleton).setAnimation( 0 , "02" , false );
                    break
            }
        }
    }

    /**
     * 恢复镜头
     */
    recoveryCamera(){
        let that = this;
        cc.tween( this.cameraNode )
            .to( 0.2 , { x : 0 , y : 0 } )
            .call(()=>{
                that.cameraFlag = false;
            })
            .start();
        cc.tween( this.cameraNode.getComponent( cc.Camera ) )
            .to( 0.5 , { zoomRatio : 1 })
            .start();
        this.btnSounderNode.active = true;
        this.btnDigNode.active = false;
    }

    /**
     * 收入背包
     */
    incomeBackpack( goodsId : number ){
        this.getOreArray.push( goodsId );
        this.mCurrPackageCount ++;
        NormalGameManager._instance.onPushGoods( goodsId , 1 );
        O1HD.emit("OreItemNode.takeAway" , this.mCurrIndex );
        this._refreshBackpack();
    }

    /**
     * 添加
     */
    onBtnPackage(){
        if ( this.mCanUsePackageCount == 9 ) {
            O1HD.getModules().uiControlModule.showMessageBox("已是最大容量" );
            return;
        }
        this.openEnlargeCapacity();
    }

    openEnlargeCapacity(){
        let node = cc.instantiate( this.packageEnlargeCapacityPrefab );
        node.getComponent( PackageEnlargeCapacity ).bindData( this );
        this.uiNode.addChild( node );
    }

    /**
     * 添加背包容量
     */
    addPackageCapacityCount(){
        this.mCanUsePackageCount += 3;
        this._refreshBackpack();
    }

    //刷新背包
    private _refreshBackpack(){
        this.btnPackageNode.getChildByName("actualUseLb").getComponent(cc.Label).string = `${this.mCurrPackageCount}`;
        this.btnPackageNode.getChildByName("packageLb").getComponent(cc.Label).string = `${this.mCanUsePackageCount}`;
    }

}
